import React, { useState } from 'react';
import { Image as Img, View } from 'react-native';
import { AspectRatioToken, BorderRadiusTokens, ImageSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
const ImageBase = ({ uri, defaultUri, size = ImageSizeTokens.LG, height, width, borderRadius = BorderRadiusTokens.BR0, borderBottomRadius, borderTopRadius, aspectRatio = AspectRatioToken.A1_1, borderColor, boxBorderColor, bgColor, padding = SizeTypeTokens.SM, resizeMode, }) => {
    const theme = ThemeProvider.getTheme();
    const sizeValue = theme.imageSize[size];
    const aspectRatioValue = theme.aspectRatio[aspectRatio];
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const borderTopRadiusValue = theme.borderRadius[borderTopRadius];
    const borderBottomRadiusValue = theme.borderRadius[borderBottomRadius];
    const borderColorValue = theme.colors[borderColor];
    const bgColorValue = theme.colors[bgColor];
    const boxSizeValue = Number(theme.imageSize[size]) + 15;
    const boxBorderColorValue = theme.colors[boxBorderColor];
    const paddingValue = theme.paddingSize[padding];
    if (!uri || !size)
        return React.createElement(React.Fragment, null);
    const [imageError, setError] = useState(false);
    const viewStyleProps = React.useMemo(() => ({
        height: 'auto',
        padding: paddingValue,
        backgroundColor: bgColorValue,
        borderRadius: borderRadiusValue,
        borderWidth: borderColor ? 3 : 0,
        borderColor: boxBorderColorValue,
    }), [
        paddingValue,
        bgColorValue,
        borderRadiusValue,
        boxBorderColorValue,
    ]);
    const styleProps = React.useMemo(() => ({
        width: width || sizeValue,
        height: height || sizeValue || 'auto',
        borderRadius: borderRadiusValue,
        borderTopLeftRadius: borderTopRadiusValue,
        borderTopRightRadius: borderTopRadiusValue,
        borderBottomLeftRadius: borderBottomRadiusValue,
        borderBottomRightRadius: borderBottomRadiusValue,
        borderWidth: borderColor ? 3 : 0,
        aspectRatio: aspectRatioValue,
        borderColor: borderColorValue,
        resizeMode: resizeMode,
    }), [
        sizeValue,
        borderRadiusValue,
        borderColorValue,
        borderTopRadiusValue,
        borderBottomRadiusValue,
        aspectRatioValue,
    ]);
    return (React.createElement(View, { style: viewStyleProps },
        React.createElement(Img, { defaultSource: { uri: defaultUri }, onError: () => setError(true), style: styleProps, source: {
                uri: imageError ? defaultUri : uri,
            } })));
};
export { ImageBase };
